import React, { FC } from 'react'
import Link from 'next/link'
import { useTranslation } from 'next-i18next/pages'
import { useUI } from '@corratech/pylot-ui/context'
import { useWishlist } from './Hooks/use-wishlist'
import { NoWishlistItems } from './WishlistItems'
import { ErrorPage } from '@components/common/ErrorPage'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import { Wishlist as WishlistType } from '@pylot-data/pylotschema'
import cn from 'classnames'
import s from '@pagestyles/Wishlist.module.scss'
import formStyles from '@commonStyles/Forms.module.scss'
import { WishlistCollection } from './WishlistItems/WishlistCollection'
import {
    AccountRowChevronIcon,
    AccountWishlistIcon
} from '@components/account/AccountHomeQuickLinkIcons'

export const Wishlist: FC = () => {
    const { t } = useTranslation(['wishlist', 'account', 'common'])
    const { LoadingIndicator } = useUI()
    const { wishlists, loading, error } = useWishlist({
        revalidateOnFocus: false
    })
    const config = useStoreConfig()

    if (!config.base.wishlist.enabled) {
        return <div>{t('wishlist|Wish list is not currently available.')}</div>
    }

    if (error) {
        return <ErrorPage />
    }

    if (loading) {
        return (
            <div className="mx-auto max-w-xs">
                <LoadingIndicator />
            </div>
        )
    }

    const filteredWishlists: WishlistType[] = wishlists?.filter(
        Boolean
    ) as WishlistType[]

    return (
        <div className={cn(s['wishlist-container'], formStyles.root)}>
            <Link
                href="/account"
                className={s.backLink}
                aria-label={t('account||account|My Account')}
            >
                <span className={s.backChevron}>
                    <AccountRowChevronIcon />
                </span>
                <span className={s.backText}>
                    {t('account||account|My Account')}
                </span>
            </Link>
            <div className={s.profileHeading}>
                <AccountWishlistIcon aria-hidden />
                <h1 className={s.profileTitle}>
                    {t('account||account|My Wish List')}
                </h1>
            </div>
            {wishlists?.length ? (
                <WishlistCollection wishlists={filteredWishlists!} />
            ) : (
                <NoWishlistItems />
            )}
        </div>
    )
}
